<template>
  <div class="space-y-8">
    <div class="space-y-5">
      <div class="form-control">
        <input
          type="text"
          class="input input-bordered input-lg w-full rounded-xl bg-base-100 border-2 focus:border-primary transition-colors"
          :placeholder="$t('smartLeadForm.contact.namePlaceholder')"
          v-model="name" />
      </div>
      
      <div class="form-control">
        <input
          type="email"
          class="input input-bordered input-lg w-full rounded-xl bg-base-100 border-2 focus:border-primary transition-colors"
          :placeholder="$t('smartLeadForm.contact.emailPlaceholder')"
          v-model="email" />
      </div>
    </div>

    <button 
      class="btn btn-primary btn-lg w-full rounded-xl font-medium disabled:opacity-50" 
      :disabled="!valid" 
      @click="$emit('next')">
      {{ $t("smartLeadForm.contact.cta") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

const name = computed({
  get: () => (typeof props.modelValue.name === "string" ? props.modelValue.name : ""),
  set: (val: string) => emit("update:modelValue", { ...props.modelValue, name: val }),
});

const email = computed({
  get: () => (typeof props.modelValue.email === "string" ? props.modelValue.email : ""),
  set: (val: string) => emit("update:modelValue", { ...props.modelValue, email: val }),
});

const valid = computed(() => {
  return name.value.length > 1 && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value);
});
</script>
